/* eslint-disable import/namespace */
import cx from 'classnames';
import PropTypes from 'prop-types';

import Icon from '@ant-design/icons';
import * as icons from '$src/utils/lazy-load-asset';

import IconView from '$src/assets/icons/IconView.svg';

import './index.less';

const CustomIcon = ({ name, className, type, ...restProps }) => {
  const Component = icons[`${type}Icons`][name]?.default ?? IconView;
  return <Icon component={Component} className={cx('custom-icon', className)} {...restProps} />;
};

CustomIcon.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['regular']).isRequired,
  className: PropTypes.string,
};

export { CustomIcon };
